/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostSavingsBase {
    getFixupPrototypeFunction() { return CostSavingsBase.fixupPrototype; }

    static newInstance(model: Partial<CostSavingsBase>): CostSavingsBase {
        let obj = Object.assign(new CostSavingsBase(), model);
        CostSavingsBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostSavingsBase>): CostSavingsBase {
        if (!model) return null;
        return CostSavingsBase.newInstance(<CostSavingsBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostSavingsBase) {
        if (!obj) return;

        models.CostSavingsBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostSavingsBase): boolean {
        Object.setPrototypeOf(obj, CostSavingsBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.end_date === "string") {
            this.end_date = new Date(<string><any>this.end_date);
        }
        if (this.savings_details) {
            for (let val of this.savings_details) {
                models.CostSavingsMetrics.fixupPrototype(val);
            }
        }
    }

    /**
     * Indicates the source for the costs saving
     */
    savings_source: models.CostSavingSource;

    /**
     * Time considered for generating the cost saving.
     */
    start_date: Date;

    /**
     * Time considered for generating the cost saving.
     */
    end_date: Date;

    /**
     * Time considered for generating the cost saving.
     */
    unit_of_measure: string;

    savings_details: Array<models.CostSavingsMetrics>;

}
